"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.marketTypeMap = exports.pageTypeMap = exports.searchParamsMap = exports.filters = void 0;
exports.filters = [
    {
        label: "Terkait",
        value: "terkait",
    },
    {
        label: "Produk A-Z",
        value: "asc",
    },
    {
        label: "Produk Z-A",
        value: "desc",
    },
    {
        label: "Termurah",
        value: "termurah",
    },
];
exports.searchParamsMap = [
    {
        old: "category",
        new: "category",
    },
    {
        old: "province",
        new: "province_id",
    },
    {
        old: "brand_id",
        new: "brand_id",
    },
    {
        old: "keyword",
        new: "title",
    },
    {
        old: "minrange",
        new: "price_range",
    },
    {
        old: "maxrange",
        new: "price_range",
    },
    {
        old: "pg",
        new: "page",
    },
    {
        old: "by",
        new: "sales",
    },
    {
        old: "is_store",
        new: "is_store",
    },
    {
        old: "is_umkm",
        new: "is_umkm",
    },
    {
        old: "dekranas_id",
        new: "dekranas_id",
    },
    {
        old: "is_gkp",
        new: "is_gkp",
    },
];
exports.pageTypeMap = {
    category: {
        newName: "category",
        index: 3,
    },
    brand: {
        newName: "brand_id",
        index: 2,
    },
    store: {
        newName: "brand_id",
        index: 4,
    },
    dekranas: {
        newName: "dekranas_id",
        index: 4,
    },
    umkm: {
        newName: "category",
        index: 4,
    },
};
exports.marketTypeMap = {
    store: {
        paramName: "is_store",
        paramValue: 1,
    },
    umkm: {
        paramName: "is_umkm",
        paramValue: 1,
    },
    dekranas: {
        paramName: "dekranas_id",
        paramValue: 'all',
    },
    gkp: {
        paramName: "is_gkp",
        paramValue: 1,
    },
};
